import { render, staticRenderFns } from "./appTitle.vue?vue&type=template&id=5cc3f7c4&scoped=true"
import script from "./appTitle.vue?vue&type=script&lang=js"
export * from "./appTitle.vue?vue&type=script&lang=js"
import style0 from "./appTitle.vue?vue&type=style&index=0&id=5cc3f7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3f7c4",
  null
  
)

export default component.exports